var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateCw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FOCUSED MODE MEDIA MODALS BOOK AND ACTIVITY SIZE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4615 -2589C-4615 -2590.1 -4614.1 -2591 -4613 -2591H4782C4783.1 -2591 4784 -2590.1 4784 -2589V190C4784 191.104 4783.1 192 4782 192H-4613C-4614.1 192 -4615 191.104 -4615 190V-2589Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4613 -2590H4782V-2592H-4613V-2590ZM4783 -2589V190H4785V-2589H4783ZM4782 191H-4613V193H4782V191ZM-4614 190V-2589H-4616V190H-4614ZM-4613 191C-4613.55 191 -4614 190.552 -4614 190H-4616C-4616 191.657 -4614.66 193 -4613 193V191ZM4783 190C4783 190.552 4782.55 191 4782 191V193C4783.66 193 4785 191.657 4785 190H4783ZM4782 -2590C4782.55 -2590 4783 -2589.55 4783 -2589H4785C4785 -2590.66 4783.66 -2592 4782 -2592V-2590ZM-4613 -2592C-4614.66 -2592 -4616 -2590.66 -4616 -2589H-4614C-4614 -2589.55 -4613.55 -2590 -4613 -2590V-2592Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "student focused mode with image preview open in activity - horizontally longer",
    clipPath: "url(#clip0_6444_16538)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    transform: "translate(-792 -1069)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "activity completetion mode"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_6444_16538",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-72 -989C-72 -993.418 -68.4183 -997 -64 -997H936V48H-72V-989Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-72 -989C-72 -993.418 -68.4183 -997 -64 -997H936V48H-72V-989Z",
    fill: "#FAFAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-73 -989C-73 -993.971 -68.9706 -998 -64 -998H936V-996H-64C-67.866 -996 -71 -992.866 -71 -989H-73ZM936 48H-72H936ZM-73 48V-989C-73 -993.971 -68.9706 -998 -64 -998V-996C-67.866 -996 -71 -992.866 -71 -989V48H-73ZM936 -997V48V-997Z",
    fill: "#9D9690",
    mask: "url(#path-3-inside-1_6444_16538)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "centerfold video view"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 570",
    x: -32,
    y: -997,
    width: 856,
    height: 1045,
    rx: 4,
    fill: "#2E2E2D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 1797"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -4,
    width: 299,
    height: 32,
    rx: 4,
    fill: "#2E2E2D",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "rotate-cw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 4V10H17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.49 15C19.84 16.8399 18.6096 18.4187 16.9842 19.4985C15.3588 20.5783 13.4265 21.1006 11.4784 20.9866C9.53038 20.8726 7.67216 20.1286 6.18376 18.8667C4.69536 17.6047 3.65743 15.8932 3.22637 13.9901C2.79531 12.0869 2.99448 10.0952 3.79386 8.31508C4.59325 6.53496 5.94954 5.06288 7.65836 4.12065C9.36717 3.17843 11.3359 2.81711 13.268 3.09116C15.2 3.3652 16.9906 4.25975 18.37 5.64001L23 10",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6444_16538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1728,
    height: 1117,
    fill: "white",
    transform: "translate(-792 -1069)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCw);
export default __webpack_public_path__ + "static/media/rotate-cw.bec92c1bc96832cce074040c52c37305.svg";
export { ForwardRef as ReactComponent };